import { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";

const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_API_URL_PROD // https://demenagementsamyyhaul.ca/api
    : process.env.REACT_APP_API_URL_DEV; // http://158.69.205.231:3000

// Composant Sidebar avec navigation corrigée
const Sidebar = ({ activeTab, setActiveTab }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const userId = currentUser?.id || "me"; // fallback "me" si jamais pas d'id
  const menuItems = [
    {
      id: "new-quote",
      label: "Tableau de bord",
      icon: "📊",
      path: `/user/${userId}`,
    },
    {
      id: "my-quotes",
      label: "Mes Devis",
      icon: "📋",
      path: `/user/my-quotes/${userId}`,
    },
    {
      id: "collaborations", // NOUVEAU
      label: "Collaborations",
      icon: "🤝",
      path: `/user/collaborations/${userId}`,
    },
    {
      id: "profile",
      label: "Mon Profile",
      icon: "🏢",
      path: `/user/profile/${userId}`,
    },
  ];

  const handleMenuClick = (item) => {
    setActiveTab(item.id);
    navigate(item.path);
    setIsOpen(false);
  };

  return (
    <>
      {/* Header mobile avec bouton burger */}
      <div className="md:hidden fixed left-0 right-0 flex items-center p-4 z-50 bg-white shadow-sm">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="text-2xl focus:outline-none mr-3"
        >
          {isOpen ? "✖" : "☰"}
        </button>
        <h2 className="font-bold text-lg">Menu</h2>
      </div>

      {/* Overlay pour mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-40 md:hidden"
          onClick={() => setIsOpen(false)}
        ></div>
      )}

     {/* Sidebar */}
<aside
  className={`fixed top-0 left-0 h-screen w-64 bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out
  ${isOpen ? "translate-x-0" : "-translate-x-full"}
  md:translate-x-0 md:relative md:shadow-none`}
>
  {/* Header de la sidebar avec bouton fermeture 
  <div className="flex justify-between items-center p-4 border-b md:hidden">
    <h2 className="font-bold text-lg">Menu</h2>
    <button
      onClick={() => setIsOpen(false)}
      className="text-2xl text-gray-600 hover:text-gray-800 focus:outline-none"
    >
      ✖
    </button>
  </div>*/}

  {/* ESPACE AUGMENTÉ pour le header mobile */}
  <div className="h-20 md:h-0"></div>
  
  <nav className="p-4 flex flex-col gap-4">
    {menuItems.map((item) => (
      <button
        key={item.id}
        onClick={() => {
          handleMenuClick(item);
          setIsOpen(false); // Ferme le menu après clic
        }}
        className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 w-full
          ${
            activeTab === item.id
              ? "bg-blue-100 text-blue-700 font-semibold shadow-lg"
              : "text-gray-600 hover:bg-gray-50 hover:shadow"
          }`}
      >
        <span className="text-2xl">{item.icon}</span>
        <span className="text-md font-medium">{item.label}</span>
      </button>
    ))}
  </nav>
</aside>
    </>
  );
};

export default function UserPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const [quotes, setQuotes] = useState([]);
  const [userProfile, setUserProfile] = useState({
    id: "",
    name: "",
    firstName: "",
    lastName: "",
    email: "",
    tel: "",
    address: "",
    profilPicture: "",
    userStatus: "",
    role: "",
    mailStatus: false,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [profileLoading, setProfileLoading] = useState(false);

  const [newQuote, setNewQuote] = useState({
    from: "",
    to: "",
    movingDate: "",
    notes: "",
    description: "",
  });

  const [services, setServices] = useState([]);

  // Récupération de l'ID utilisateur depuis le localStorage ou token
  const getCurrentid = () => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

    return currentUser.id || currentUser.id || null;
  };

  const fetchUserProfile = async () => {
    const id = getCurrentid();
    if (!id) {
      setError("Utilisateur non trouvé. Veuillez vous reconnecter.");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");

      const response = await fetch(`${API_BASE_URL}/users/${id}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (!response.ok) {
        throw new Error(`Erreur ${response.status}: ${response.statusText}`);
      }

      const responseData = await response.json();

      // Extraction sécurisée des données utilisateur
      let userData;

      if (responseData.data && responseData.data.user) {
        userData = responseData.data.user;
      } else if (responseData.user) {
        userData = responseData.user;
      } else if (responseData.data) {
        userData = responseData.data; // Ajout pour gérer le format {data: {...}}
      } else {
        userData = responseData;
      }

      console.log("Données utilisateur complètes:", userData);
      console.log("Champ tel reçu:", userData.tel); // Debug spécifique pour tel

      // Mapper les données API vers votre structure locale
      setUserProfile({
        id: userData.id || id,
        name: `${userData.firstName || ""} ${userData.lastName || ""}`.trim(),
        firstName: userData.firstName || "",
        lastName: userData.lastName || "",
        email: userData.email || "",
        tel: userData.tel || "", // Assurez-vous que ce mapping est correct
        address: userData.address || "",
        profilPicture: userData.profilPicture || "",
        userStatus: userData.userStatus || "",
        role: userData.role || "",
        mailStatus: userData.mailStatus || false,
      });

      setError(null);
    } catch (err) {
      console.error("Erreur lors de la récupération du profil:", err);
      setError("Impossible de charger le profil utilisateur");
    } finally {
      setLoading(false);
    }
  };

  const handleSaveProfile = async () => {
    const id = getCurrentid();
    if (!id) {
      alert("Erreur: Utilisateur non trouvé");
      return;
    }

    try {
      setProfileLoading(true);
      const token = localStorage.getItem("authToken");

      // Préparer les données pour l'API - format correct
      const updateData = {
        firstName: userProfile.firstName,
        lastName: userProfile.lastName,
        email: userProfile.email,
        tel: userProfile.tel, // Ce champ est bien inclus
        address: userProfile.address,
      };

      console.log("Tentative de mise à jour avec:", updateData);

      // Utiliser directement l'endpoint documenté
      const response = await fetch(`${API_BASE_URL}/users/${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: JSON.stringify(updateData),
      });

      console.log("Réponse status:", response.status);

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Erreur détaillée:", errorData);

        if (response.status === 404) {
          throw new Error("Utilisateur non trouvé");
        } else {
          throw new Error(
            `Erreur ${response.status}: ${
              errorData.message || response.statusText
            }`
          );
        }
      }

      const result = await response.json();
      console.log("✅ Réponse du serveur après mise à jour:", result);

      // CORRECTION IMPORTANTE : Mettre à jour le localStorage avec les nouvelles données
      const currentUser = JSON.parse(
        localStorage.getItem("currentUser") || "{}"
      );
      const updatedUser = {
        ...currentUser,
        firstName: userProfile.firstName,
        lastName: userProfile.lastName,
        email: userProfile.email,
        tel: userProfile.tel, // ← METTRE À JOUR LE TÉLÉPHONE DANS LE LOCALSTORAGE
        address: userProfile.address,
      };

      localStorage.setItem("currentUser", JSON.stringify(updatedUser));
      console.log(
        "✅ localStorage mis à jour avec le téléphone:",
        userProfile.tel
      );

      // Vérifier si le téléphone a été mis à jour
      if (result.tel) {
        console.log("✅ Téléphone mis à jour avec succès:", result.tel);
      }

      // Actualiser les données après la sauvegarde
      await fetchUserProfile();
      alert("Profil mis à jour avec succès !");
    } catch (err) {
      console.error("Erreur lors de la sauvegarde:", err);
      alert(`Erreur lors de la sauvegarde du profil: ${err.message}`);
    } finally {
      setProfileLoading(false);
    }
  };
  // États pour la gestion de l'image
  const [profilePictureLoading, setProfilePictureLoading] = useState(false);

  // Fonction pour uploader l'image vers Cloudinary via votre endpoint de test
  const handleProfilePictureChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validation du fichier
    if (!file.type.startsWith("image/")) {
      alert("Veuillez sélectionner une image valide");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      alert("L'image ne doit pas dépasser 5MB");
      return;
    }

    try {
      setProfilePictureLoading(true);

      // Créer un FormData pour l'upload
      const formData = new FormData();
      formData.append("image", file);

      const token = localStorage.getItem("authToken");

      console.log("Début upload vers Cloudinary...");

      const response = await fetch(`${API_BASE_URL}/test-upload/single-image`, {
        method: "POST",
        headers: {
          // Ne pas mettre Content-Type pour FormData, le navigateur le fera automatiquement
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: formData,
      });

      console.log("Réponse serveur:", response);

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Erreur response:", errorText);
        throw new Error(`Erreur ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      console.log("Résultat Cloudinary:", result);

      // Extraire l'URL de l'image depuis la réponse Cloudinary
      let imageUrl;

      if (result.secure_url) {
        // Format direct Cloudinary
        imageUrl = result.secure_url;
      } else if (result.data && result.data.secure_url) {
        // Format encapsulé
        imageUrl = result.data.secure_url;
      } else if (result.url) {
        // Autre format possible
        imageUrl = result.url;
      } else {
        console.warn("Format de réponse inattendu:", result);
        throw new Error("Format de réponse inattendu de Cloudinary");
      }

      // Mettre à jour l'état local avec la nouvelle image
      setUserProfile((prev) => ({
        ...prev,
        profilPicture: imageUrl,
      }));

      // Optionnel: Sauvegarder l'URL dans le profil utilisateur
      await saveProfilePictureToUser(imageUrl);

      alert("Photo de profil mise à jour avec succès !");
    } catch (error) {
      console.error("Erreur upload photo:", error);
      alert(`Erreur lors de l'upload de la photo: ${error.message}`);
    } finally {
      setProfilePictureLoading(false);
      // Réinitialiser l'input file
      event.target.value = "";
    }
  };

  // Fonction pour sauvegarder l'URL de l'image dans le profil utilisateur
  const saveProfilePictureToUser = async (imageUrl) => {
    try {
      const id = getCurrentid();
      const token = localStorage.getItem("authToken");

      const updateData = {
        profilPicture: imageUrl,

        // Vous pouvez ajouter d'autres champs si nécessaire
      };

      const response = await fetch(`${API_BASE_URL}/users/${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: JSON.stringify(updateData),
      });

      if (!response.ok) {
        console.warn(
          "Impossible de sauvegarder la photo dans le profil, mais elle est uploadée sur Cloudinary"
        );
        return;
      }

      console.log("Photo sauvegardée dans le profil utilisateur");
    } catch (error) {
      console.error("Erreur sauvegarde profil:", error);
      // Ne pas bloquer l'utilisateur si cette étape échoue
    }
  };
  const [passwordSection, setPasswordSection] = useState(false);
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState("");
  const [resetPasswordData, setResetPasswordData] = useState({
    email: "",
    verificationCode: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [passwordMessage, setPasswordMessage] = useState("");
  const [isPasswordSuccess, setIsPasswordSuccess] = useState(false);
  const [isLoadingPassword, setIsLoadingPassword] = useState(false);

  // Fonction pour envoyer le code de vérification
  const handleForgotPassword = async () => {
    if (!forgotPasswordEmail) {
      setPasswordMessage("Veuillez entrer votre adresse email");
      setIsPasswordSuccess(false);
      return;
    }

    try {
      setIsLoadingPassword(true);
      setPasswordMessage("");

      const response = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: forgotPasswordEmail }),
      });

      if (response.status === 201) {
        setPasswordMessage("✅ Code de vérification envoyé à votre email");
        setIsPasswordSuccess(true);
        // Pré-remplir l'email dans le formulaire de reset
        setResetPasswordData((prev) => ({
          ...prev,
          email: forgotPasswordEmail,
        }));
      } else {
        const errorData = await response.json();
        setPasswordMessage(
          `❌ ${errorData.message || "Erreur lors de l'envoi du code"}`
        );
        setIsPasswordSuccess(false);
      }
    } catch (error) {
      console.error("Erreur forgot password:", error);
      setPasswordMessage("❌ Erreur de connexion au serveur");
      setIsPasswordSuccess(false);
    } finally {
      setIsLoadingPassword(false);
    }
  };

  // Fonction pour réinitialiser le mot de passe
  const handleResetPassword = async () => {
    // Validation
    if (resetPasswordData.newPassword !== resetPasswordData.confirmPassword) {
      setPasswordMessage("❌ Les mots de passe ne correspondent pas");
      setIsPasswordSuccess(false);
      return;
    }

    if (resetPasswordData.newPassword.length < 6) {
      setPasswordMessage(
        "❌ Le mot de passe doit contenir au moins 6 caractères"
      );
      setIsPasswordSuccess(false);
      return;
    }

    try {
      setIsLoadingPassword(true);
      setPasswordMessage("");

      const response = await fetch(`${API_BASE_URL}/auth/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: resetPasswordData.email,
          verificationCode: resetPasswordData.verificationCode,
          newPassword: resetPasswordData.newPassword,
        }),
      });

      if (response.ok) {
        setPasswordMessage("✅ Mot de passe réinitialisé avec succès !");
        setIsPasswordSuccess(true);
        // Réinitialiser le formulaire
        setResetPasswordData({
          email: "",
          verificationCode: "",
          newPassword: "",
          confirmPassword: "",
        });
        setForgotPasswordEmail("");

        // Fermer la section après 2 secondes
        setTimeout(() => {
          setPasswordSection(false);
        }, 2000);
      } else {
        const errorData = await response.json();
        setPasswordMessage(
          `❌ ${errorData.message || "Erreur lors de la réinitialisation"}`
        );
        setIsPasswordSuccess(false);
      }
    } catch (error) {
      console.error("Erreur reset password:", error);
      setPasswordMessage("❌ Erreur de connexion au serveur");
      setIsPasswordSuccess(false);
    } finally {
      setIsLoadingPassword(false);
    }
  };

  // Fonction pour gérer les changements dans le formulaire
  const handlePasswordChange = (field, value) => {
    setResetPasswordData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  useEffect(() => {
    if (userProfile.email) {
      setForgotPasswordEmail(userProfile.email);
      setResetPasswordData((prev) => ({
        ...prev,
        email: userProfile.email,
      }));
    }
  }, [userProfile.email]);

  // Fonction pour formater automatiquement le code de vérification
  const handleVerificationCodeChange = (value) => {
    // N'autoriser que les chiffres
    const numericValue = value.replace(/\D/g, "");
    // Limiter à 6 chiffres
    const formattedValue = numericValue.slice(0, 6);
    handlePasswordChange("verificationCode", formattedValue);
  };
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const userId = currentUser?.id || "me";

  // Maintenant getActiveTabFromURL peut utiliser userId
  const getActiveTabFromURL = () => {
    const path = location.pathname;
    if (path === `/user/${userId}` || path === "/user/") return "new-quote";
    if (path === `/user/my-quotes/${userId}`) return "my-quotes";
    if (path === `/user/collaborations/${userId}`) return "collaborations"; // NOUVEAU

    if (path === `/user/profile/${userId}`) return "profile";
    return "new-quote"; // Par défaut
  };

  const [activeTab, setActiveTab] = useState(getActiveTabFromURL());

  // Synchroniser l'onglet actif avec l'URL
  useEffect(() => {
    const currentTab = getActiveTabFromURL();
    console.log("Setting active tab to:", currentTab); // Debug
    setActiveTab(currentTab);

    // Si l'URL est juste "/user", rediriger vers le tableau de bord
    if (location.pathname === "/user" || location.pathname === "/user/") {
      setActiveTab("new-quote");
    }
  }, [location.pathname]);

  // Appelez cette fonction temporairement dans votre useEffect
  useEffect(() => {
    fetchUserProfile();
    fetchAllUserDemands();
  }, []);

  // Ajoutez ces états avec les autres useState
  const [servicesLoading, setServicesLoading] = useState(false);

  // Fonction pour charger les services
  const fetchServices = async () => {
    try {
      setServicesLoading(true);
      const response = await fetch(`${API_BASE_URL}/services`);

      if (!response.ok) {
        throw new Error("Erreur lors du chargement des services");
      }

      const data = await response.json();

      if (data.statusCode === 200 && data.data?.services) {
        setServices(data.data.services);
      } else if (Array.isArray(data)) {
        setServices(data);
      } else if (data.services) {
        setServices(data.services);
      }
    } catch (err) {
      console.error("Erreur API services :", err);
      setError("Erreur lors du chargement des services");
    } finally {
      setServicesLoading(false);
    }
  };

  // Modifiez le useEffect existant pour utiliser cette fonction
  useEffect(() => {
    fetchServices();
  }, []);
  const linkGuestDemandsToUser = async () => {
    const guestToken = localStorage.getItem("guestToken");
    const userId = getCurrentid();

    if (!guestToken || !userId) {
      console.log("❌ Liaison impossible: token guest ou user ID manquant");
      return { success: false, linkedCount: 0 };
    }

    try {
      const token = localStorage.getItem("authToken");

      const response = await fetch(`${API_BASE_URL}/demandes/link-to-user`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: JSON.stringify({
          guestToken: guestToken,
          userId: userId,
        }),
      });

      if (response.ok) {
        const result = await response.json();
        console.log(
          "✅ Liaison réussie:",
          result.data?.linkedCount,
          "demandes liées"
        );

        if (result.success && result.data?.linkedCount > 0) {
          localStorage.removeItem("guestToken");
          return { success: true, linkedCount: result.data.linkedCount };
        }
        return { success: false, linkedCount: 0 };
      } else {
        console.error("❌ Erreur liaison");
        return { success: false, linkedCount: 0 };
      }
    } catch (error) {
      console.error("❌ Erreur réseau liaison:", error);
      return { success: false, linkedCount: 0 };
    }
  };
  // Liaison automatique des demandes guest après connexion
  useEffect(() => {
    const checkAndLinkGuestDemands = async () => {
      const userId = getCurrentid();
      const guestToken = localStorage.getItem("guestToken");

      if (userId && guestToken) {
        console.log(
          "Utilisateur connecté avec token guest - liaison automatique"
        );
        const success = await linkGuestDemandsToUser();
        if (success) {
          console.log("Demandes guest liées avec succès");
        }
      }
    };

    checkAndLinkGuestDemands();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("currentUser");
    window.location.href = "/login";
  };

  const handleProfileUpdate = (field, value) => {
    setUserProfile((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Accepté":
      case "Approuvé":
        return "bg-emerald-100 text-emerald-800 border-emerald-200";
      case "Terminé":
      case "En cours":
        return "bg-blue-100 text-blue-800 border-blue-200";
      case "Refusé":
      case "Refusée":
        return "bg-red-100 text-red-800 border-red-200";
      case "PENDING":
      case "En attente":
      default:
        return "bg-amber-100 text-amber-800 border-amber-200";
    }
  };

  const handleRefreshProfile = () => {
    fetchUserProfile();
  };
  // Fonction pour changer le statut d'une collaboration
  const handleCollaborationStatusChange = async (id, newStatus) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(
        `${API_BASE_URL}/collaboration/${id}/status`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ statut: newStatus }),
        }
      );

      if (!response.ok) {
        throw new Error("Erreur lors de la mise à jour du statut");
      }

      // Mettre à jour l'état local
      setCollaborations((prev) =>
        prev.map((collab) =>
          collab.id === id ? { ...collab, statut: newStatus } : collab
        )
      );
    } catch (error) {
      console.error("Erreur lors du changement de statut:", error);
      alert("Erreur lors de la mise à jour du statut");
    }
  };

  // Ajouter dans les useEffect existants :
  useEffect(() => {
    if (activeTab === "company") {
      fetchCollaborations();
    }
  }, [activeTab]);
  // États pour la recherche et le regroupement (à ajouter dans votre composant principal)
  const [searchTerm, setSearchTerm] = useState("");
  const [groupBy, setGroupBy] = useState("none");
  const [sortBy, setSortBy] = useState("id");
  const [sortOrder, setSortOrder] = useState("asc");
  // Fonctions pour gérer les actions
  // Fonctions pour gérer les actions
  const [selectedQuote, setSelectedQuote] = useState(null);
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  // Fonction pour ouvrir les détails d'une demande
  const handleViewDetails = (quote) => {
    setSelectedQuote(quote);
    setIsQuoteModalOpen(true);
  };

  // Fonction pour fermer la modal des demandes
  const handleCloseQuoteModal = () => {
    setIsQuoteModalOpen(false);
    setSelectedQuote(null);
  };

  const handleCancelDemand = async (demandId) => {
    if (!window.confirm("Êtes-vous sûr de vouloir annuler cette demande ?")) {
      return;
    }

    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(
        `${API_BASE_URL}/demandes/${demandId}/status`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
          body: JSON.stringify({ statut: "Annulée" }),
        }
      );

      if (response.ok) {
        alert("Demande annulée avec succès");
        // Recharger les demandes
        fetchAllUserDemands();
      } else {
        throw new Error("Erreur lors de l'annulation");
      }
    } catch (error) {
      console.error("Erreur:", error);
      alert("Erreur lors de l'annulation de la demande");
    }
  };

  // Options de regroupement
  const groupOptions = [
    { value: "none", label: "Aucun regroupement" },
    { value: "status", label: "Par statut" },
    { value: "type", label: "Par type de service" },
    { value: "from", label: "Par ville de départ" },
    { value: "to", label: "Par ville d'arrivée" },
  ];

  // Fonction de filtrage des devis
  const filteredQuotes = useMemo(() => {
    return quotes.filter((quote) => {
      const searchLower = searchTerm.toLowerCase();
      return (
        quote.id.toString().includes(searchLower) ||
        quote.type.toLowerCase().includes(searchLower) ||
        quote.from.toLowerCase().includes(searchLower) ||
        quote.to.toLowerCase().includes(searchLower) ||
        quote.status.toLowerCase().includes(searchLower) ||
        quote.notes.toLowerCase().includes(searchLower) ||
        quote.price.toLowerCase().includes(searchLower) ||
        quote.date.includes(searchLower)
      );
    });
  }, [quotes, searchTerm]);

  // Fonction de regroupement des devis
  const groupedQuotes = useMemo(() => {
    if (groupBy === "none") {
      return { "Tous les devis": filteredQuotes };
    }

    return filteredQuotes.reduce((groups, quote) => {
      const key = quote[groupBy] || "Non défini";
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(quote);
      return groups;
    }, {});
  }, [filteredQuotes, groupBy]);

  // Fonction de tri
  const sortedGroupedQuotes = useMemo(() => {
    const sorted = {};
    Object.keys(groupedQuotes).forEach((groupKey) => {
      sorted[groupKey] = [...groupedQuotes[groupKey]].sort((a, b) => {
        let aValue = a[sortBy];
        let bValue = b[sortBy];

        // Conversion pour les IDs
        if (sortBy === "id") {
          aValue = parseInt(aValue);
          bValue = parseInt(bValue);
        }

        // Conversion pour les dates
        if (sortBy === "date") {
          aValue = new Date(aValue);
          bValue = new Date(bValue);
        }

        if (sortOrder === "asc") {
          return aValue > bValue ? 1 : -1;
        } else {
          return aValue < bValue ? 1 : -1;
        }
      });
    });
    return sorted;
  }, [groupedQuotes, sortBy, sortOrder]);

  // Fonction pour obtenir le nombre total de devis
  const getTotalQuotes = () => {
    return Object.values(sortedGroupedQuotes).flat().length;
  };

  // Fonction pour obtenir les statistiques par statut
  const getStatusStats = () => {
    const stats = {};
    Object.values(sortedGroupedQuotes)
      .flat()
      .forEach((quote) => {
        stats[quote.status] = (stats[quote.status] || 0) + 1;
      });
    return stats;
  };
  // Dans PageUser.js, ajoutez ces fonctions

  // Fonction pour récupérer les demandes guest (avant connexion)
  // Fonction pour récupérer les demandes guest (avant connexion)
  const fetchGuestDemands = async () => {
    const guestToken = localStorage.getItem("guestToken");
    if (!guestToken) {
      console.log("Aucun token guest trouvé");
      return [];
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/demandes/guest/${guestToken}`
      );
      if (response.ok) {
        const guestDemands = await response.json();
        console.log("Demandes guest récupérées:", guestDemands);
        return guestDemands;
      }
      return [];
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des demandes guest:",
        error
      );
      return [];
    }
  };
  const fetchUserDemandes = async () => {
    const id = getCurrentid();
    if (!id) {
      setError("Utilisateur non trouvé. Veuillez vous reconnecter.");
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");

      // ✅ CORRECTION : Récupérer l'email depuis le localStorage directement
      const currentUser = JSON.parse(
        localStorage.getItem("currentUser") || "{}"
      );
      const currentEmail = (currentUser.email || userProfile.email || "")
        .toLowerCase()
        .trim();

      console.log("🔍 === VERSION CORRIGÉE - FILTRAGE MULTI-CRITÈRES ===");
      console.log("🔍 User ID:", id);
      console.log("🔍 Current Email:", currentEmail);

      const response = await fetch(`${API_BASE_URL}/demandes`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();
      console.log("🔍 Réponse complète de /demandes:", responseData);

      // Extraction universelle
      let allDemands = [];
      if (Array.isArray(responseData)) allDemands = responseData;
      else if (Array.isArray(responseData.data)) allDemands = responseData.data;
      else if (Array.isArray(responseData.data?.demands))
        allDemands = responseData.data.demands;
      else if (Array.isArray(responseData.demands))
        allDemands = responseData.demands;

      console.log("🔍 Toutes les demandes récupérées:", allDemands.length);

      // === FILTRAGE CORRIGÉ ===
      const userIdStr = String(id);

      const userDemands = allDemands.filter((demande) => {
        // 1. Vérifier par userId direct
        const hasUserId =
          demande.userId && String(demande.userId) === userIdStr;

        // 2. Vérifier par user object
        const hasUserObject =
          demande.user && String(demande.user.id) === userIdStr;

        // 3. Vérifier par email client - CORRECTION IMPORTANTE
        const demandeEmail = (demande.clientEmail || "").toLowerCase().trim();
        const hasEmailMatch = currentEmail && demandeEmail === currentEmail;

        const match = hasUserId || hasUserObject || hasEmailMatch;

        // Log détaillé pour les demandes qui nous intéressent
        if (demandeEmail === "eya@gmail.com" || match) {
          console.log(`🔍 Analyse détaillée demande ${demande.id}:`, {
            demandeId: demande.id,
            demandeUserId: demande.userId,
            demandeUserObj: demande.user ? demande.user.id : "null",
            demandeEmail: demande.clientEmail,
            currentEmail: currentEmail,
            hasUserId,
            hasUserObject,
            hasEmailMatch,
            match,
          });
        }

        return match;
      });

      console.log(
        `✅ ${userDemands.length} demandes LIÉES trouvées pour l'utilisateur ${id}`
      );

      // Afficher le détail des demandes trouvées
      userDemands.forEach((demande) => {
        console.log(
          `📋 Demande trouvée: ${demande.id} - ${demande.serviceType} - ${demande.clientEmail}`
        );
      });

      // Transformation pour affichage
      const transformedQuotes = userDemands.map((demande) => {
        const from =
          demande.departureAddress?.city ||
          demande.pickupAddress?.city ||
          demande.fromAddress?.city ||
          "Non spécifié";

        const to =
          demande.arrivalAddress?.city ||
          demande.destinationAddress?.city ||
          demande.toAddress?.city ||
          "Non spécifié";

        const date =
          demande.serviceDate ||
          demande.preferredStartDate ||
          demande.movingDate ||
          "Non spécifié";
        const notes = demande.notes || "Aucune note";

        const typeMap = {
          demenagement: "Déménagement",
          livraison: "Livraison",
          ramassage: "Ramassage",
          moving: "Déménagement",
          delivery: "Livraison",
          pickup: "Ramassage",
        };

        const type =
          typeMap[demande.serviceType] ||
          typeMap[demande.type] ||
          demande.serviceType ||
          demande.type ||
          "Non spécifié";

        let priceDisplay = "En attente";
        if (demande.devis) {
          if (typeof demande.devis === "number") {
            priceDisplay = `€${demande.devis}`;
          } else if (typeof demande.devis === "string") {
            priceDisplay = `€${parseFloat(demande.devis) || "En attente"}`;
          }
        } else if (demande.price) {
          if (typeof demande.price === "number") {
            priceDisplay = `€${demande.price}`;
          } else if (typeof demande.price === "string") {
            priceDisplay = `€${parseFloat(demande.price) || "En attente"}`;
          }
        }

        return {
          id: demande.id || "N/A",
          from,
          to,
          date,
          status: demande.statut || demande.status || "En attente",
          notes,
          price: priceDisplay,
          type,
          originalData: demande,
        };
      });

      console.log("✅ Quotes transformées finales:", transformedQuotes);
      setQuotes(transformedQuotes);
      setError(null);

      // Vérification finale
      if (userDemands.length !== 2) {
        console.warn(
          `⚠️ ATTENTION: ${userDemands.length} demandes trouvées au lieu de 2 attendues`
        );
        console.log(
          "🔍 Recherche des demandes manquantes dans la réponse complète:"
        );
        allDemands.forEach((demande) => {
          if (demande.clientEmail === "eya@gmail.com") {
            console.log(`🔍 Demande avec email eya@gmail.com:`, {
              id: demande.id,
              userId: demande.userId,
              clientEmail: demande.clientEmail,
              serviceType: demande.serviceType,
            });
          }
        });
      }
    } catch (err) {
      console.error("❌ Erreur lors de la récupération des demandes:", err);
      setError("Impossible de charger vos demandes");
    } finally {
      setLoading(false);
      console.log("🔍 === FIN fetchUserDemandes ===");
    }
  };

  const fetchAllUserDemands = async () => {
    const id = getCurrentid();
    const guestToken = localStorage.getItem("guestToken");

    try {
      setLoading(true);
      setError(null);

      console.log("🔄 Début du chargement des demandes...");

      // ✅ CORRECTION : S'assurer que l'email est disponible
      const currentUser = JSON.parse(
        localStorage.getItem("currentUser") || "{}"
      );
      if (!currentUser.email && !userProfile.email) {
        console.log("🔄 Chargement du profil utilisateur...");
        await fetchUserProfile();
      }

      console.log("🔍 Email utilisé:", currentUser.email || userProfile.email);

      // ✅ OPTIMISATION : Exécuter en parallèle quand possible
      if (id && guestToken) {
        console.log(
          "🔄 Utilisateur connecté avec token guest - traitement parallèle"
        );

        const [liaisonResult] = await Promise.allSettled([
          linkGuestDemandsToUser(),
        ]);

        await fetchUserDemandes();

        if (
          liaisonResult.status === "fulfilled" &&
          liaisonResult.value.success
        ) {
          console.log(
            `✅ ${liaisonResult.value.linkedCount} demandes liées avec succès`
          );
        }
      } else if (id && !guestToken) {
        console.log("🔄 Utilisateur connecté - chargement normal");
        await fetchUserDemandes();
      } else if (!id && guestToken) {
        console.log("🔄 Utilisateur non connecté - chargement guest");
        await loadGuestDemands(guestToken);
      } else {
        setQuotes([]);
      }
    } catch (error) {
      console.error("❌ Erreur dans fetchAllUserDemands:", error);
      setError("Erreur lors du chargement des demandes");
    } finally {
      setLoading(false);
    }
  };
  // Fonction pour charger les demandes guest (à ajouter si elle n'existe pas)
  const loadGuestDemands = async (guestToken) => {
    try {
      console.log("🔄 Chargement des demandes guest avec token:", guestToken);

      const guestDemands = await fetchGuestDemands();

      // Transformer les données guest pour l'affichage
      const transformedQuotes = guestDemands.map((demande) => {
        let fromAddress = "Non spécifié";
        if (demande.departureAddress) {
          fromAddress = `${demande.departureAddress.fullAddress || ""}, ${
            demande.departureAddress.city || ""
          }`.trim();
          if (fromAddress === ",") fromAddress = "Non spécifié";
        } else if (demande.pickupAddress) {
          fromAddress = `${demande.pickupAddress.fullAddress || ""}, ${
            demande.pickupAddress.city || ""
          }`.trim();
          if (fromAddress === ",") fromAddress = "Non spécifié";
        }

        let toAddress = "Non spécifié";
        if (demande.arrivalAddress) {
          toAddress = `${demande.arrivalAddress.fullAddress || ""}, ${
            demande.arrivalAddress.city || ""
          }`.trim();
          if (toAddress === ",") toAddress = "Non spécifié";
        }

        let formattedDate = "Non spécifié";
        if (demande.serviceDate) {
          formattedDate = demande.serviceDate;
        } else if (demande.preferredStartDate) {
          formattedDate = new Date(demande.preferredStartDate)
            .toISOString()
            .split("T")[0];
        }
        // Par ceci :
        const notes = demande.notes ? demande.notes.trim() : "Aucune note";
        if (notes === "" || notes === ",") {
          notes = "Aucune note";
        }

        const mapServiceType = (serviceType) => {
          const typeMap = {
            demenagement: "Déménagement",
            livraison: "Livraison",
            ramassage: "Ramassage",
          };
          return typeMap[serviceType] || serviceType;
        };

        return {
          id: demande.id,
          from: fromAddress,
          to: toAddress,
          date: formattedDate,
          status: demande.statut || "En attente",
          notes: demande.notes,
          price: demande.devis ? `€${demande.devis}` : "En attente",
          type: mapServiceType(demande.serviceType),
          originalData: demande,
          isGuest: true,
        };
      });

      console.log(`✅ ${transformedQuotes.length} demandes guest transformées`);
      setQuotes(transformedQuotes);
    } catch (error) {
      console.error("❌ Erreur lors du chargement des demandes guest:", error);
      setError("Erreur lors du chargement des demandes temporaires");
    }
  };
  // Liaison automatique des demandes guest après connexion
  useEffect(() => {
    const checkAndLinkGuestDemands = async () => {
      const userId = getCurrentid();
      const guestToken = localStorage.getItem("guestToken");

      if (userId && guestToken) {
        console.log(
          "Utilisateur connecté avec token guest - liaison automatique"
        );
        await linkGuestDemandsToUser();
      }
    };

    checkAndLinkGuestDemands();
  }, []);

  const GuestDemandsNotification = () => {
    const guestToken = localStorage.getItem("guestToken");
    const isLoggedIn = getCurrentid();

    if (!guestToken || !isLoggedIn) return null;

    return (
      <div className="mb-6 p-4 bg-orange-50 border border-orange-200 rounded-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <span className="text-orange-500 text-xl mr-3">📋</span>
            <div>
              <h4 className="font-semibold text-orange-800">
                Demandes temporaires détectées
              </h4>
              <p className="text-orange-600 text-sm">
                Vous avez des demandes créées avant votre connexion. Voulez-vous
                les lier à votre compte ?
              </p>
            </div>
          </div>
          <button
            onClick={async () => {
              const success = await linkGuestDemandsToUser();
              if (success) {
                alert(
                  "Vos demandes ont été liées à votre compte avec succès !"
                );
              }
            }}
            className="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors text-sm font-medium"
          >
            Lier maintenant
          </button>
        </div>
      </div>
    );
  };

  const [collaborations, setCollaborations] = useState([]);
  const [collaborationsLoading, setCollaborationsLoading] = useState(false);
  const [collaborationsError, setCollaborationsError] = useState(null);
  const [collaborationSearch, setCollaborationSearch] = useState("");
  const [collaborationStatusFilter, setCollaborationStatusFilter] =
    useState("");

  const [newCollab, setNewCollab] = useState({
    nom: "",
    tel: "",
    service: "",
    typeCollaboration: "",
    description: "",
  });
  const createCollaboration = async (e) => {
    e.preventDefault();

    // CORRECTION : Récupérer l'email depuis currentUser
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    const email = currentUser.email;

    if (!email) {
      alert("Utilisateur non connecté.");
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/Collaboration`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...newCollab,
          email, // Utiliser l'email de currentUser
          statut: "En cours",
        }),
      });

      if (!response.ok) throw new Error("Erreur création collaboration");

      const created = await response.json();
      console.log("✅ Collaboration créée :", created);

      // Mettre à jour la liste sans recharger la page
      await fetchCollaborations();
      setNewCollab({
        nom: "",
        tel: "",
        service: "",
        typeCollaboration: "",
        description: "",
      });

      alert("Collaboration créée avec succès !");
    } catch (err) {
      console.error("❌ Erreur création collaboration :", err);
      alert("Erreur lors de la création de la collaboration");
    }
  };
  const fetchCollaborations = async () => {
    console.log("🔄 Chargement des collaborations...");
    const token = localStorage.getItem("authToken");

    // CORRECTION : Récupérer l'email depuis currentUser au lieu de userEmail
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    const userEmail = currentUser.email;

    if (!userEmail) {
      console.warn("❌ Aucun email utilisateur trouvé dans currentUser");
      setCollaborations([]);
      return;
    }

    try {
      setCollaborationsLoading(true);
      const response = await fetch(`${API_BASE_URL}/Collaboration`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      if (!response.ok)
        throw new Error("Erreur lors du chargement des collaborations");

      const data = await response.json();
      console.log("📦 Réponse API Collaboration :", data);

      // 🔹 Filtrer par email de l'utilisateur connecté
      const userCollabs = data.filter(
        (item) =>
          item.email && item.email.toLowerCase() === userEmail.toLowerCase()
      );

      console.log(
        `✅ ${userCollabs.length} collaborations trouvées pour ${userEmail}`
      );
      setCollaborations(userCollabs);
    } catch (error) {
      console.error("❌ Erreur lors du fetch collaborations :", error);
      setCollaborationsError("Erreur lors du chargement des collaborations");
    } finally {
      setCollaborationsLoading(false);
    }
  };

  const [selectedCollaboration, setSelectedCollaboration] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  // Fonction pour ouvrir les détails d'une collaboration
  const handleViewCollaborationDetails = (collaboration) => {
    setSelectedCollaboration(collaboration);
    setIsDetailsModalOpen(true);
  };

  // Fonction pour fermer la modal
  const handleCloseDetailsModal = () => {
    setIsDetailsModalOpen(false);
    setSelectedCollaboration(null);
  };

  // Fonction pour récupérer une collaboration spécifique
  const fetchCollaborationById = async (id) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`${API_BASE_URL}/Collaboration/${id}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (!response.ok) {
        throw new Error(`Erreur ${response.status}: ${response.statusText}`);
      }

      const collaboration = await response.json();
      return collaboration;
    } catch (err) {
      console.error("Erreur lors de la récupération de la collaboration:", err);
      throw err;
    }
  };
  // === RÉCUPÉRER LES COLLABORATIONS INVITÉ ===
  const fetchGuestCollaborations = async () => {
    const guestToken = localStorage.getItem("guestToken");
    if (!guestToken) return [];
    try {
      const response = await fetch(
        `${API_BASE_URL}/collaboration/guest/${guestToken}`
      );
      if (!response.ok) throw new Error("Erreur API");
      const data = await response.json();
      return data.data || data.collaborations || data || [];
    } catch (err) {
      console.error(
        "Erreur lors de la récupération des collaborations invité :",
        err
      );
      return [];
    }
  };

  const linkGuestCollaborationsToUser = async () => {
    const guestToken = localStorage.getItem("guestToken");
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    const userId = currentUser.id;

    if (!guestToken || !userId) return;

    try {
      const response = await fetch(
        `${API_BASE_URL}/Collaboration/link-to-user`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ guestToken, userId }),
        }
      );

      if (!response.ok)
        throw new Error("Erreur liaison collaborations invitées");
      console.log("✅ Collaborations invitées liées au compte");
      localStorage.removeItem("guestToken");
      await fetchCollaborations(); // recharge la liste liée à l'utilisateur
    } catch (err) {
      console.error("❌ Erreur liaison guest collaborations :", err);
    }
  };

  useEffect(() => {
    const checkAndLinkGuestCollaborations = async () => {
      const userId = getCurrentid();
      const guestToken = localStorage.getItem("guestToken");
      if (userId && guestToken) {
        await linkGuestCollaborationsToUser();
      }
    };
    checkAndLinkGuestCollaborations();
  }, []);
  const GuestCollaborationsNotification = () => {
    const guestToken = localStorage.getItem("guestToken");
    const isLoggedIn = getCurrentid();
    if (!guestToken || !isLoggedIn) return null;

    return (
      <div className="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <span className="text-yellow-600 text-xl mr-3">🤝</span>
            <div>
              <h4 className="font-semibold text-yellow-800">
                Collaborations invitées détectées
              </h4>
              <p className="text-yellow-700 text-sm">
                Vous avez des collaborations créées avant connexion.
                Souhaitez-vous les lier à votre compte ?
              </p>
            </div>
          </div>
          <button
            onClick={linkGuestCollaborationsToUser}
            className="px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 transition"
          >
            Lier maintenant
          </button>
        </div>
      </div>
    );
  };
  useEffect(() => {
    if (activeTab === "collaborations") {
      fetchCollaborations();
    }
  }, [activeTab]);

  // Fonction pour gérer la recherche
  const handleCollaborationSearch = () => {
    fetchCollaborations();
  };

  // Fonction pour réinitialiser les filtres
  const resetCollaborationFilters = () => {
    setCollaborationSearch("");
    setCollaborationStatusFilter("");
    fetchCollaborations();
  };

  // Affichage de l'erreur critique
  if (error && loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-2xl p-8 border border-white/20 text-center max-w-md">
          <div className="text-red-500 text-4xl mb-4">⚠️</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Erreur de chargement
          </h2>
          <p className="text-gray-600 mb-6">{error}</p>
          <div className="flex space-x-4 justify-center">
            <button
              onClick={handleRefreshProfile}
              className="px-6 py-3 bg-blue-500 text-white rounded-xl hover:bg-blue-600 transition-colors"
            >
              Réessayer
            </button>
            <button
              onClick={handleLogout}
              className="px-6 py-3 bg-gray-200 text-gray-700 rounded-xl hover:bg-gray-300 transition-colors"
            >
              Se déconnecter
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <br />
      <br />
      <br />
      <br />

      {/* Navigation avec design moderne */}
      <div className="flex">
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
        {/* Contenu principal */}
        {activeTab === "new-quote" && (
          <div className="space-y-8 lg:space-y-12 px-4 sm:px-6 lg:px-8 pt-16 sm:pt-8 lg:pt-0">
            {/* En-tête principal */}
            <div className="text-center px-2 pt-8 sm:pt-4 lg:pt-0">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800 mb-3 lg:mb-4">
                Choisissez votre service
              </h2>
              <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-2xl mx-auto">
                Découvrez nos services professionnels adaptés à tous vos besoins
                de transport et logistique
              </p>
            </div>

            {/* Grille des services */}
            {servicesLoading ? (
              <div className="flex justify-center items-center py-12 lg:py-20 mt-8 sm:mt-0">
                <div className="flex items-center space-x-3 sm:space-x-4">
                  <div className="animate-spin rounded-full h-8 w-8 sm:h-12 sm:w-12 border-b-2 border-blue-500"></div>
                  <span className="text-gray-600 text-sm sm:text-lg">
                    Chargement des services...
                  </span>
                </div>
              </div>
            ) : services.length === 0 ? (
              <div className="text-center py-12 lg:py-20 px-4 mt-8 sm:mt-0">
                <div className="text-gray-400 text-4xl sm:text-6xl mb-4">
                  🚚
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-3 sm:mb-4">
                  Aucun service disponible
                </h3>
                <p className="text-gray-600 max-w-md mx-auto text-sm sm:text-base">
                  Les services sont temporairement indisponibles. Veuillez
                  réessayer plus tard.
                </p>
                <button
                  onClick={fetchServices}
                  className="mt-4 sm:mt-6 px-4 sm:px-6 py-2 sm:py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors text-sm sm:text-base"
                >
                  Réessayer
                </button>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-7xl mx-auto pt-8 sm:pt-4 lg:pt-0">
                {services.map((service, index) => (
                  <div
                    key={service.id}
                    className="group bg-white rounded-xl sm:rounded-2xl shadow-lg sm:shadow-xl overflow-hidden transform transition-all duration-500 hover:-translate-y-1 sm:hover:-translate-y-2 hover:shadow-xl sm:hover:shadow-2xl border border-gray-100"
                  >
                    {/* Image du service */}
                    <div className="relative h-48 sm:h-56 lg:h-64 overflow-hidden">
                      <img
                        src={service.imageUrl || "/default-service.jpg"}
                        alt={service.name}
                        className="w-full h-full object-cover transition duration-700 group-hover:scale-110"
                        onError={(e) => {
                          e.target.src = "/default-service.jpg";
                        }}
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                      {/* Overlay avec nom du service */}
                      <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4 right-3 sm:right-4">
                        <h3 className="text-lg sm:text-xl font-bold text-white drop-shadow-lg">
                          {service.name}
                        </h3>
                      </div>
                    </div>

                    {/* Contenu du service */}
                    <div className="p-4 sm:p-6">
                      <p className="text-gray-600 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
                        {service.description}
                      </p>

                      <Link
                        to={`/${service.name
                          .replace(/\s+/g, "")
                          .toLowerCase()}`}
                        className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white font-semibold py-2 sm:py-3 px-4 sm:px-6 rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-300 transform hover:scale-105 shadow-lg text-center block text-sm sm:text-base"
                      >
                        <span className="flex items-center justify-center gap-2">
                          Demander un devis
                          <span className="transform group-hover:translate-x-1 transition-transform">
                            →
                          </span>
                        </span>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {/* Section Entreprise en vedette - MOBILE FIRST */}
            <div className="relative bg-gradient-to-r from-red-50 to-orange-50 rounded-2xl lg:rounded-3xl p-4 sm:p-6 lg:p-8 border-2 border-red-200 shadow-xl lg:shadow-2xl max-w-4xl mx-auto mt-8 sm:mt-4 lg:mt-0">
              {/* Badge Entreprise */}
              <div className="absolute -top-3 sm:-top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-red-600 text-white px-4 sm:px-6 py-1 sm:py-2 rounded-full text-xs sm:text-sm font-bold shadow-lg whitespace-nowrap">
                  🏢 PARTENARIAT ENTREPRISE
                </span>
              </div>

              <div className="flex flex-col lg:flex-row items-center justify-between gap-4 sm:gap-6 pt-2">
                <div className="flex-1 text-center lg:text-left">
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">
                    Collaboration Professionnelle
                  </h3>
                  <p className="text-gray-600 mb-3 sm:mb-4 text-sm sm:text-base">
                    Solutions sur mesure pour les entreprises et partenaires
                  </p>
                  <div className="flex flex-col sm:flex-row flex-wrap items-center justify-center lg:justify-start gap-2 sm:gap-3 text-xs sm:text-sm text-gray-500">
                    <span className="flex items-center gap-1">
                      <span className="text-green-500">✅</span> Devis
                      personnalisé
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="text-green-500">✅</span> Support dédié
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="text-green-500">✅</span> Tarifs négociés
                    </span>
                  </div>
                </div>

                <div className="flex-shrink-0 w-full sm:w-auto mt-4 sm:mt-0">
                  <Link
                    to="/collaboration-entreprise"
                    className="group relative inline-flex items-center justify-center bg-red-600 text-white font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-xl shadow-lg transition-all duration-300 hover:scale-105 hover:bg-red-700 hover:shadow-xl min-h-[50px] sm:min-h-[60px] w-full sm:w-auto text-center"
                  >
                    <span className="mr-2 sm:mr-3 text-base sm:text-lg">
                      🤝
                    </span>
                    <div className="text-left">
                      <div className="whitespace-nowrap font-semibold text-sm sm:text-base">
                        Demander un partenariat
                      </div>
                      <div className="whitespace-nowrap text-xs font-normal opacity-90 hidden sm:block">
                        Service entreprise
                      </div>
                    </div>
                    <span className="ml-2 sm:ml-3 transform group-hover:translate-x-1 transition-transform">
                      →
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeTab === "my-quotes" && (
          <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {loading ? (
              <div className="flex items-center justify-center py-12">
                <div className="flex items-center space-x-4">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                  <span className="text-gray-600">
                    Chargement de vos demandes...
                  </span>
                </div>
              </div>
            ) : (
              <div className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-2xl overflow-hidden border border-white/20">
                {/* En-tête avec titre et boutons */}
                <div className="bg-gradient-to-r from-gray-50 to-blue-50 px-8 py-6 border-b border-gray-200">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                    <div>
                      <h2 className="text-2xl font-bold text-gray-800 flex items-center">
                        <span className="text-3xl mr-3">📋</span>
                        Mes Demandes de Service
                      </h2>
                      <p className="text-gray-600 mt-2">
                        Suivez l'état de toutes vos demandes ({getTotalQuotes()}{" "}
                        demandes)
                      </p>
                    </div>
                    <GuestDemandsNotification />
                    <div className="flex items-center space-x-4 mt-4 sm:mt-0">
                      {/* Statistiques rapides */}
                      <div className="flex space-x-4">
                        {Object.entries(getStatusStats()).map(
                          ([status, count]) => (
                            <div key={status} className="text-center">
                              <div className="text-lg font-bold text-gray-800">
                                {count}
                              </div>
                              <div className="text-xs text-gray-500">
                                {status}
                              </div>
                            </div>
                          )
                        )}
                      </div>

                      {/* Bouton de rafraîchissement */}
                      <button
                        onClick={fetchAllUserDemands}
                        disabled={loading}
                        className="p-2 text-gray-500 hover:text-blue-500 transition-colors disabled:opacity-50"
                        title="Actualiser les demandes"
                      >
                        🔄
                      </button>
                    </div>
                  </div>
                </div>

                {/* Barre de recherche et filtres */}
                <div className="px-8 py-6 bg-gray-50/50 border-b border-gray-200">
                  <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0 lg:space-x-4">
                    {/* Barre de recherche */}
                    <div className="relative flex-1 max-w-md">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <svg
                          className="h-5 w-5 text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          />
                        </svg>
                      </div>
                      <input
                        type="text"
                        placeholder="Rechercher dans tous les champs..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-xl leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                      {searchTerm && (
                        <button
                          onClick={() => setSearchTerm("")}
                          className="absolute inset-y-0 right-0 pr-3 flex items-center"
                        >
                          <svg
                            className="h-5 w-5 text-gray-400 hover:text-gray-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      )}
                    </div>

                    {/* Contrôles de regroupement et tri */}
                    <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4">
                      {/* Regroupement */}
                      <div className="flex items-center space-x-2">
                        <label className="text-sm font-medium text-gray-700 whitespace-nowrap">
                          Regrouper par:
                        </label>
                        <select
                          value={groupBy}
                          onChange={(e) => setGroupBy(e.target.value)}
                          className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white text-sm"
                        >
                          {groupOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Tri */}
                      <div className="flex items-center space-x-2">
                        <label className="text-sm font-medium text-gray-700 whitespace-nowrap">
                          Trier par:
                        </label>
                        <select
                          value={sortBy}
                          onChange={(e) => setSortBy(e.target.value)}
                          className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white text-sm"
                        >
                          <option value="id">ID</option>
                          <option value="date">Date</option>
                          <option value="status">Statut</option>
                          <option value="type">Type</option>
                          <option value="from">Départ</option>
                          <option value="to">Arrivée</option>
                        </select>
                        <button
                          onClick={() =>
                            setSortOrder(sortOrder === "asc" ? "desc" : "asc")
                          }
                          className="px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                          title={
                            sortOrder === "asc"
                              ? "Tri croissant"
                              : "Tri décroissant"
                          }
                        >
                          <svg
                            className={`h-4 w-4 text-gray-600 transition-transform ${
                              sortOrder === "desc" ? "rotate-180" : ""
                            }`}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Indicateurs de filtrage actifs */}
                  {(searchTerm || groupBy !== "none") && (
                    <div className="flex flex-wrap items-center gap-2 mt-4">
                      {searchTerm && (
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                          Recherche: "{searchTerm}"
                          <button
                            onClick={() => setSearchTerm("")}
                            className="ml-2 text-blue-600 hover:text-blue-800"
                          >
                            ×
                          </button>
                        </span>
                      )}
                      {groupBy !== "none" && (
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                          Groupé par:{" "}
                          {
                            groupOptions.find((opt) => opt.value === groupBy)
                              ?.label
                          }
                          <button
                            onClick={() => setGroupBy("none")}
                            className="ml-2 text-green-600 hover:text-green-800"
                          >
                            ×
                          </button>
                        </span>
                      )}
                      <button
                        onClick={() => {
                          setSearchTerm("");
                          setGroupBy("none");
                          setSortBy("id");
                          setSortOrder("asc");
                        }}
                        className="text-xs text-gray-500 hover:text-gray-700 underline"
                      >
                        Réinitialiser tous les filtres
                      </button>
                    </div>
                  )}
                </div>

                {/* Affichage des résultats */}
                <div className="overflow-x-auto">
                  {Object.entries(sortedGroupedQuotes).length === 0 ? (
                    <div className="px-8 py-12 text-center">
                      <div className="text-gray-400 text-4xl mb-4">🔍</div>
                      <h3 className="text-lg font-medium text-gray-900 mb-2">
                        Aucune demande trouvée
                      </h3>
                      <p className="text-gray-500">
                        Aucune demande ne correspond à vos critères de
                        recherche.
                      </p>
                    </div>
                  ) : (
                    Object.entries(sortedGroupedQuotes).map(
                      ([groupName, groupQuotes]) => (
                        <div key={groupName} className="mb-6">
                          {/* En-tête de groupe (si regroupement actif) */}
                          {groupBy !== "none" && (
                            <div className="px-8 py-4 bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-blue-200">
                              <h3 className="text-lg font-semibold text-gray-800 flex items-center">
                                <span className="w-4 h-4 bg-blue-500 rounded-full mr-3"></span>
                                {groupName}
                                <span className="ml-2 text-sm font-normal text-gray-600">
                                  ({groupQuotes.length} demandes)
                                </span>
                              </h3>
                            </div>
                          )}

                          {/* Tableau */}
                          <table className="min-w-full">
                            <thead className="bg-gradient-to-r from-gray-100 to-blue-100">
                              <tr>
                                {[
                                  "ID",
                                  "Service",
                                  "Trajet",
                                  "Date",

                                  "Prix estimé",
                                  "Statut",
                                  "Actions",
                                ].map((header) => (
                                  <th
                                    key={header}
                                    className="px-6 py-4 text-left text-sm font-semibold text-gray-700"
                                  >
                                    {header}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-100">
                              {groupQuotes.map((quote, index) => (
                                <tr
                                  key={`${groupName}-${quote.id}`}
                                  className={`hover:bg-blue-50/50 transition-colors duration-200 ${
                                    index % 2 === 0
                                      ? "bg-white"
                                      : "bg-gray-50/30"
                                  }`}
                                >
                                  <td className="px-6 py-4">
                                    <span className="font-mono text-sm bg-gray-100 px-2 py-1 rounded">
                                      #{quote.id}
                                    </span>
                                  </td>
                                  <td className="px-6 py-4">
                                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                                      {quote.type}
                                    </span>
                                  </td>
                                  <td className="px-6 py-4">
                                    <div className="flex items-center space-x-2">
                                      <span className="font-medium">
                                        {quote.from}
                                      </span>
                                      <svg
                                        className="w-4 w-4 text-gray-400"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M17 8l4 4m0 0l-4 4m4-4H3"
                                        />
                                      </svg>
                                      <span className="font-medium">
                                        {quote.to}
                                      </span>
                                    </div>
                                  </td>
                                  <td className="px-6 py-4 text-gray-600">
                                    {quote.date}
                                  </td>

                                  <td className="px-6 py-4">
                                    <span className="font-semibold text-green-600">
                                      {quote.price}
                                    </span>
                                  </td>
                                  <td className="px-6 py-4">
                                    <span
                                      className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border ${getStatusColor(
                                        quote.status
                                      )}`}
                                    >
                                      {quote.status}
                                    </span>
                                  </td>
                                  <td className="px-6 py-4">
                                    <div className="flex space-x-2">
                                      <button
                                        onClick={() => handleViewDetails(quote)}
                                        className="text-blue-600 hover:text-blue-800 font-medium hover:bg-blue-50 px-3 py-1 rounded-lg transition-colors"
                                      >
                                        Détails
                                      </button>
                                      {quote.status === "En attente" && (
                                        <button
                                          onClick={() =>
                                            handleCancelDemand(quote.id)
                                          }
                                          className="text-red-600 hover:text-red-800 font-medium hover:bg-red-50 px-3 py-1 rounded-lg transition-colors"
                                        >
                                          Annuler
                                        </button>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )
                    )
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === "collaborations" && (
          <div className="bg-gray-50 min-h-screen p-8 w-full">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-3xl font-bold text-gray-800 border-b pb-2">
                🤝 Mes Collaborations
              </h2>
              <button
                onClick={fetchCollaborations}
                disabled={collaborationsLoading}
                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:opacity-50 flex items-center gap-2"
              >
                🔄 {collaborationsLoading ? "Chargement..." : "Actualiser"}
              </button>
            </div>

            {/* Notification guest collaborations */}
            <GuestCollaborationsNotification />

            {/* Statistiques simples */}
            <div className="flex gap-6 mb-8">
              <div className="bg-green-50 p-4 rounded-xl border border-green-200 flex-1 text-center">
                <p className="text-sm text-green-600 font-medium">Approuvées</p>
                <p className="text-2xl font-bold text-green-700">
                  {collaborations.filter((c) => c.statut === "Approuvé").length}
                </p>
              </div>
              <div className="bg-yellow-50 p-4 rounded-xl border border-yellow-200 flex-1 text-center">
                <p className="text-sm text-yellow-600 font-medium">En cours</p>
                <p className="text-2xl font-bold text-yellow-700">
                  {collaborations.filter((c) => c.statut === "En cours").length}
                </p>
              </div>
              <div className="bg-red-50 p-4 rounded-xl border border-red-200 flex-1 text-center">
                <p className="text-sm text-red-600 font-medium">Refusées</p>
                <p className="text-2xl font-bold text-red-700">
                  {collaborations.filter((c) => c.statut === "Refusée").length}
                </p>
              </div>
            </div>
            {/* Tableau des collaborations AVEC DÉTAILS */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Nom / Entreprise
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Contact
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Service & Type
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Statut
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Détails
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {collaborations.length === 0 ? (
                    <tr>
                      <td
                        colSpan="5"
                        className="text-center py-8 text-gray-500"
                      >
                        Aucune collaboration trouvée
                      </td>
                    </tr>
                  ) : (
                    collaborations.map((collab) => (
                      <tr
                        key={collab.id}
                        className="hover:bg-blue-50 transition"
                      >
                        <td className="px-6 py-4 font-medium text-gray-900">
                          {collab.nom}
                          <div className="text-sm text-gray-500">
                            {new Date(collab.createdAt).toLocaleDateString(
                              "fr-FR"
                            )}
                          </div>
                        </td>
                        <td className="px-6 py-4 text-gray-700">
                          <div>{collab.email}</div>
                          <div>{collab.tel}</div>
                        </td>
                        <td className="px-6 py-4 text-gray-700">
                          <div>{collab.service}</div>
                          <div className="text-sm text-gray-500">
                            {collab.typeCollaboration}
                          </div>
                        </td>
                        <td className="px-6 py-4">
                          <span
                            className={`inline-flex px-3 py-1 text-sm font-semibold rounded-full ${
                              collab.statut === "Approuvé"
                                ? "bg-green-100 text-green-800 border border-green-200"
                                : collab.statut === "Refusée"
                                ? "bg-red-100 text-red-800 border border-red-200"
                                : "bg-yellow-100 text-yellow-800 border border-yellow-200"
                            }`}
                          >
                            {collab.statut}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <button
                            onClick={() =>
                              handleViewCollaborationDetails(collab)
                            }
                            className="inline-flex items-center px-4 py-2 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors font-medium text-sm"
                          >
                            <svg
                              className="w-4 h-4 mr-2"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                              />
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                              />
                            </svg>
                            Détails
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {activeTab === "profile" && (
          <>
            {loading ? (
              <div className="flex items-center justify-center min-h-screen bg-white">
                <div className="flex items-center space-x-4">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                  <span className="text-gray-600">Chargement du profil...</span>
                </div>
              </div>
            ) : (
              <div className="min-h-screen w-full bg-white p-4 sm:p-6 lg:p-10">
                {/* Header profil */}
                <div className="flex items-center space-x-4 mb-8 sm:mb-12 border-b pb-4 sm:pb-6">
                  <span className="text-3xl sm:text-4xl">👤</span>
                  <div>
                    <h2 className="text-2xl sm:text-3xl font-bold text-gray-800">
                      Mon Profil
                    </h2>
                    <p className="text-gray-600 text-sm sm:text-base">
                      Gérez vos informations personnelles
                    </p>
                  </div>
                  <button
                    onClick={handleRefreshProfile}
                    className="ml-auto p-2 text-gray-500 hover:text-blue-500 transition-colors"
                    title="Actualiser"
                  >
                    🔄
                  </button>
                </div>

                {/* Infos utilisateur */}
                <div className="flex flex-col sm:flex-row items-start space-y-6 sm:space-y-0 sm:space-x-6 lg:space-x-8 mb-8 sm:mb-12">
                  <div className="relative group self-center sm:self-start">
                    <img
                      src={
                        userProfile.profilPicture ||
                        "https://i.pravatar.cc/150?img=5"
                      }
                      alt="Profile"
                      className="w-24 h-24 sm:w-32 sm:h-32 rounded-lg shadow-lg ring-4 ring-blue-100"
                      onError={(e) => {
                        e.target.src = "https://i.pravatar.cc/150?img=5";
                      }}
                    />
                    {profilePictureLoading && (
                      <div className="absolute inset-0 bg-black/50 rounded-lg flex items-center justify-center">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
                      </div>
                    )}
                    <input
                      type="file"
                      id="profile-picture-input"
                      accept="image/jpeg,image/jpg,image/png,image/webp"
                      className="hidden"
                      onChange={handleProfilePictureChange}
                      disabled={profilePictureLoading}
                    />
                    <label
                      htmlFor="profile-picture-input"
                      className={`absolute inset-0 bg-black/50 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center text-white font-medium cursor-pointer text-sm sm:text-base ${
                        profilePictureLoading ? "hidden" : ""
                      }`}
                    >
                      Modifier
                    </label>
                  </div>
                  <div className="flex-1 text-center sm:text-left">
                    <h3 className="text-xl sm:text-2xl font-bold text-gray-800">
                      {userProfile.name || "Nom non défini"}
                    </h3>
                    <p className="text-gray-600 text-base sm:text-lg">
                      {userProfile.email || "Email non défini"}
                    </p>
                    <div className="mt-4 flex flex-wrap gap-2 justify-center sm:justify-start">
                      <span className="inline-flex items-center px-3 py-1 sm:px-4 sm:py-2 bg-green-100 text-green-800 rounded-full text-xs sm:text-sm font-medium">
                        ✓ {userProfile.userStatus || "Actif"}
                      </span>
                      <span className="inline-flex items-center px-3 py-1 sm:px-4 sm:py-2 bg-blue-100 text-blue-800 rounded-full text-xs sm:text-sm font-medium">
                        🏆 {userProfile.role || "Utilisateur"}
                      </span>
                      {userProfile.mailStatus && (
                        <span className="inline-flex items-center px-3 py-1 sm:px-4 sm:py-2 bg-purple-100 text-purple-800 rounded-full text-xs sm:text-sm font-medium">
                          📧 Email vérifié
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                {/* Formulaire */}
                <div className="space-y-6 sm:space-y-8">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                    {[
                      {
                        label: "Prénom",
                        type: "text",
                        value: userProfile.firstName,
                        key: "firstName",
                      },
                      {
                        label: "Nom",
                        type: "text",
                        value: userProfile.lastName,
                        key: "lastName",
                      },
                      {
                        label: "Email",
                        type: "email",
                        value: userProfile.email,
                        key: "email",
                      },
                      {
                        label: "Téléphone", // CORRECTION : Ajouté comme objet, pas comme JSX
                        type: "tel",
                        value: userProfile.tel || "",
                        key: "tel",
                        placeholder: "Votre numéro de téléphone",
                      },
                    ].map((field) => (
                      <div key={field.key} className="group">
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          {field.label}
                        </label>
                        <input
                          type={field.type}
                          value={field.value}
                          onChange={(e) =>
                            handleProfileUpdate(field.key, e.target.value)
                          }
                          className="w-full px-3 sm:px-4 py-2 sm:py-3 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm sm:text-base"
                          placeholder={field.placeholder || ""} // Ajout du placeholder si défini
                        />
                      </div>
                    ))}
                  </div>

                  <div className="group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Adresse
                    </label>
                    <textarea
                      value={userProfile.address}
                      onChange={(e) =>
                        handleProfileUpdate("address", e.target.value)
                      }
                      rows={3}
                      className="w-full px-3 sm:px-4 py-2 sm:py-3 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none text-sm sm:text-base"
                      placeholder="Votre adresse complète"
                    />
                  </div>

                  {/* Actions */}
                  <div className="flex flex-col sm:flex-row justify-end space-y-3 sm:space-y-0 sm:space-x-4">
                    <button
                      type="button"
                      onClick={handleRefreshProfile}
                      className="px-6 sm:px-8 py-2 sm:py-3 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300 transition-colors text-sm sm:text-base"
                    >
                      Actualiser
                    </button>
                    <button
                      onClick={handleSaveProfile}
                      disabled={profileLoading}
                      className="px-6 sm:px-8 py-2 sm:py-3 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg font-medium shadow hover:shadow-xl transform hover:-translate-y-0.5 transition-all disabled:opacity-50 text-sm sm:text-base"
                    >
                      {profileLoading ? "Enregistrement..." : "Enregistrer"}
                    </button>
                  </div>

                  {/* Section de changement de mot de passe */}
                  <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-gray-200">
                    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-4 sm:mb-6 space-y-3 sm:space-y-0">
                      <h3 className="text-lg sm:text-xl font-bold text-gray-800">
                        Changer le mot de passe
                      </h3>
                      <button
                        onClick={() => setPasswordSection(!passwordSection)}
                        className="px-3 sm:px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm sm:text-base"
                      >
                        {passwordSection ? "Masquer" : "Afficher"}
                      </button>
                    </div>

                    {passwordSection && (
                      <div className="bg-blue-50 p-4 sm:p-6 rounded-lg border border-blue-100">
                        {!isPasswordSuccess ? (
                          <>
                            <div className="mb-4">
                              <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Email pour réinitialisation
                              </label>
                              <input
                                type="email"
                                value={forgotPasswordEmail}
                                onChange={(e) =>
                                  setForgotPasswordEmail(e.target.value)
                                }
                                className="w-full px-3 sm:px-4 py-2 sm:py-3 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm sm:text-base"
                                placeholder="Votre adresse email"
                              />
                            </div>

                            <button
                              onClick={handleForgotPassword}
                              disabled={isLoadingPassword}
                              className="px-4 sm:px-6 py-2 sm:py-3 bg-blue-500 text-white rounded-lg font-medium hover:bg-blue-600 transition-colors disabled:opacity-50 mb-4 sm:mb-6 text-sm sm:text-base"
                            >
                              {isLoadingPassword
                                ? "Envoi en cours..."
                                : "Envoyer le code de vérification"}
                            </button>
                          </>
                        ) : null}

                        {isPasswordSuccess && (
                          <div className="space-y-4">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
                              <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                  Code de vérification
                                </label>
                                <input
                                  type="text"
                                  value={resetPasswordData.verificationCode}
                                  onChange={(e) =>
                                    handleVerificationCodeChange(e.target.value)
                                  }
                                  className="w-full px-3 sm:px-4 py-2 sm:py-3 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm sm:text-base"
                                  placeholder="Code à 6 chiffres"
                                  maxLength={6}
                                />
                              </div>

                              <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                  Nouveau mot de passe
                                </label>
                                <input
                                  type="password"
                                  value={resetPasswordData.newPassword}
                                  onChange={(e) =>
                                    handlePasswordChange(
                                      "newPassword",
                                      e.target.value
                                    )
                                  }
                                  className="w-full px-3 sm:px-4 py-2 sm:py-3 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm sm:text-base"
                                  placeholder="Minimum 6 caractères"
                                />
                              </div>
                            </div>

                            <div>
                              <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Confirmer le mot de passe
                              </label>
                              <input
                                type="password"
                                value={resetPasswordData.confirmPassword}
                                onChange={(e) =>
                                  handlePasswordChange(
                                    "confirmPassword",
                                    e.target.value
                                  )
                                }
                                className="w-full px-3 sm:px-4 py-2 sm:py-3 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm sm:text-base"
                                placeholder="Retapez votre mot de passe"
                              />
                            </div>

                            <div className="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-4">
                              <button
                                onClick={handleResetPassword}
                                disabled={isLoadingPassword}
                                className="px-4 sm:px-6 py-2 sm:py-3 bg-green-500 text-white rounded-lg font-medium hover:bg-green-600 transition-colors disabled:opacity-50 text-sm sm:text-base"
                              >
                                {isLoadingPassword
                                  ? "Traitement..."
                                  : "Réinitialiser le mot de passe"}
                              </button>

                              <button
                                onClick={() => {
                                  setPasswordSection(false);
                                  setPasswordMessage("");
                                  setIsPasswordSuccess(false);
                                }}
                                className="px-4 sm:px-6 py-2 sm:py-3 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300 transition-colors text-sm sm:text-base"
                              >
                                Annuler
                              </button>
                            </div>
                          </div>
                        )}

                        {passwordMessage && (
                          <div
                            className={`mt-4 p-3 rounded-lg text-sm font-medium ${
                              isPasswordSuccess
                                ? "bg-green-100 text-green-800 border border-green-200"
                                : "bg-red-100 text-red-800 border border-red-200"
                            }`}
                          >
                            {passwordMessage}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        {/* Modal des détails de collaboration */}
        {/* Modal des détails de collaboration */}
        {isDetailsModalOpen && selectedCollaboration && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[80vh] overflow-hidden transform transition-all">
              {/* En-tête de la modal */}
              <div className="bg-gradient-to-r from-blue-600 to-blue-800 px-8 py-6">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="bg-white/20 p-3 rounded-xl">
                      <span className="text-3xl">🤝</span>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-white">
                        Détails de la Collaboration
                      </h3>
                      <p className="text-blue-100 text-sm mt-1">
                        ID: #{selectedCollaboration.id}
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={handleCloseDetailsModal}
                    className="text-white hover:bg-white/20 p-3 rounded-xl transition-colors"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              {/* Contenu de la modal - Layout horizontal */}
              <div className="p-8 overflow-y-auto max-h-[calc(80vh-120px)]">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                  {/* Colonne de gauche - Informations principales */}
                  <div className="lg:col-span-2 space-y-6">
                    {/* Carte entreprise et statut */}
                    <div className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl p-6 border border-gray-200">
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <h4 className="text-2xl font-bold text-gray-800 mb-2">
                            {selectedCollaboration.nom}
                          </h4>
                          <p className="text-gray-600 mb-4">
                            Créée le{" "}
                            {new Date(
                              selectedCollaboration.createdAt
                            ).toLocaleDateString("fr-FR", {
                              weekday: "long",
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })}
                          </p>

                          {/* Service et Type */}
                          <div className="grid grid-cols-2 gap-4">
                            <div className="bg-white rounded-lg p-4 border border-gray-200">
                              <p className="text-sm text-gray-500 mb-1">
                                Service
                              </p>
                              <p className="font-semibold text-gray-800 text-lg">
                                {selectedCollaboration.service}
                              </p>
                            </div>
                            <div className="bg-white rounded-lg p-4 border border-gray-200">
                              <p className="text-sm text-gray-500 mb-1">Type</p>
                              <p className="font-semibold text-gray-800 text-lg">
                                {selectedCollaboration.typeCollaboration}
                              </p>
                            </div>
                          </div>
                        </div>

                        {/* Statut */}
                        <div className="flex-shrink-0 ml-6">
                          <span
                            className={`inline-flex items-center px-4 py-3 rounded-full text-base font-semibold ${
                              selectedCollaboration.statut === "Approuvé"
                                ? "bg-green-100 text-green-800 border border-green-200"
                                : selectedCollaboration.statut === "Refusée"
                                ? "bg-red-100 text-red-800 border border-red-200"
                                : "bg-yellow-100 text-yellow-800 border border-yellow-200"
                            }`}
                          >
                            {selectedCollaboration.statut}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Description */}
                    {selectedCollaboration.description && (
                      <div className="bg-white rounded-2xl p-6 border border-gray-200">
                        <h5 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                          <svg
                            className="w-5 h-5 mr-3 text-purple-500"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                            />
                          </svg>
                          Description du projet
                        </h5>
                        <div className="bg-gray-50 rounded-xl p-4">
                          <p className="text-gray-700 leading-relaxed">
                            {selectedCollaboration.description}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Colonne de droite - Informations de contact et historique */}
                  <div className="space-y-6">
                    {/* Carte contact */}
                    <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm">
                      <h5 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                        <svg
                          className="w-5 h-5 mr-3 text-blue-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                          />
                        </svg>
                        Contact
                      </h5>
                      <div className="space-y-4">
                        <div className="flex items-center space-x-4 p-3 bg-blue-50 rounded-lg">
                          <div className="bg-blue-100 p-2 rounded-lg">
                            <span className="text-blue-600 text-lg">📧</span>
                          </div>
                          <div>
                            <p className="text-sm text-gray-500">Email</p>
                            <p className="font-semibold text-gray-800">
                              {selectedCollaboration.email}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center space-x-4 p-3 bg-green-50 rounded-lg">
                          <div className="bg-green-100 p-2 rounded-lg">
                            <span className="text-green-600 text-lg">📞</span>
                          </div>
                          <div>
                            <p className="text-sm text-gray-500">Téléphone</p>
                            <p className="font-semibold text-gray-800">
                              {selectedCollaboration.tel}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Carte historique */}
                    <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm">
                      <h5 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                        <svg
                          className="w-5 h-5 mr-3 text-orange-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        Historique
                      </h5>
                      <div className="space-y-3">
                        <div className="flex items-center space-x-3">
                          <div className="flex-shrink-0 w-3 h-3 bg-blue-500 rounded-full"></div>
                          <div className="flex-1">
                            <p className="font-medium text-gray-800">
                              Demande créée
                            </p>
                            <p className="text-sm text-gray-500">
                              {new Date(
                                selectedCollaboration.createdAt
                              ).toLocaleDateString("fr-FR")}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Pied de la modal simplifié */}
              <div className="bg-gray-50 px-8 py-4 border-t border-gray-200">
                <div className="flex justify-end">
                  <button
                    onClick={handleCloseDetailsModal}
                    className="px-8 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors font-semibold shadow-lg"
                  >
                    Fermer le détail
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Modal des détails de demande */}
        {isQuoteModalOpen && selectedQuote && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[80vh] overflow-hidden transform transition-all">
              {/* En-tête de la modal */}
              <div className="bg-gradient-to-r from-green-600 to-green-800 px-8 py-6">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="bg-white/20 p-3 rounded-xl">
                      <span className="text-3xl">📋</span>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-white">
                        Détails de la Demande
                      </h3>
                      <p className="text-green-100 text-sm mt-1">
                        ID: #{selectedQuote.id}
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={handleCloseQuoteModal}
                    className="text-white hover:bg-white/20 p-3 rounded-xl transition-colors"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              {/* Contenu de la modal */}
              <div className="p-8 overflow-y-auto max-h-[calc(80vh-120px)]">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                  {/* Colonne de gauche - Informations principales */}
                  <div className="lg:col-span-2 space-y-6">
                    {/* Carte principale */}
                    <div className="bg-gradient-to-br from-gray-50 to-green-50 rounded-2xl p-6 border border-gray-200">
                      <div className="flex items-start justify-between mb-6">
                        <div className="flex-1">
                          <h4 className="text-2xl font-bold text-gray-800 mb-2">
                            Demande #{selectedQuote.id}
                          </h4>
                          <p className="text-gray-600">
                            Créée le{" "}
                            {selectedQuote.date || "Date non spécifiée"}
                          </p>
                        </div>

                        {/* Statut */}
                        <div className="flex-shrink-0 ml-6">
                          <span
                            className={`inline-flex items-center px-4 py-3 rounded-full text-base font-semibold ${getStatusColor(
                              selectedQuote.status
                            )}`}
                          >
                            {selectedQuote.status}
                          </span>
                        </div>
                      </div>

                      {/* Type de service */}
                      <div className="bg-white rounded-xl p-4 border border-gray-200 mb-4">
                        <p className="text-sm text-gray-500 mb-1">
                          Type de service
                        </p>
                        <p className="font-semibold text-gray-800 text-lg flex items-center">
                          <span className="mr-3">🚚</span>
                          {selectedQuote.type}
                        </p>
                      </div>

                      {/* Trajet */}
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="bg-white rounded-xl p-4 border border-gray-200">
                          <p className="text-sm text-gray-500 mb-2 flex items-center">
                            <svg
                              className="w-4 h-4 mr-2 text-blue-500"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                              />
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                              />
                            </svg>
                            Départ
                          </p>
                          <p className="font-semibold text-gray-800">
                            {selectedQuote.from}
                          </p>
                        </div>
                        <div className="bg-white rounded-xl p-4 border border-gray-200">
                          <p className="text-sm text-gray-500 mb-2 flex items-center">
                            <svg
                              className="w-4 h-4 mr-2 text-green-500"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                              />
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                              />
                            </svg>
                            Arrivée
                          </p>
                          <p className="font-semibold text-gray-800">
                            {selectedQuote.to}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Informations supplémentaires */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {/* Prix estimé */}
                      <div className="bg-white rounded-2xl p-6 border border-gray-200">
                        <h5 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                          <svg
                            className="w-5 h-5 mr-3 text-yellow-500"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
                            />
                          </svg>
                          Coût estimé
                        </h5>
                        <div className="text-center">
                          <p className="text-3xl font-bold text-green-600">
                            {selectedQuote.price}
                          </p>
                          <p className="text-sm text-gray-500 mt-2">
                            Prix indicatif
                          </p>
                        </div>
                      </div>

                      {/* Notes */}
                      {selectedQuote.notes &&
                        selectedQuote.notes !== "Aucune note" && (
                          <div className="bg-white rounded-2xl p-6 border border-gray-200">
                            <h5 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                              <svg
                                className="w-5 h-5 mr-3 text-purple-500"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                />
                              </svg>
                              Notes supplémentaires
                            </h5>
                            <div className="bg-gray-50 rounded-xl p-4">
                              <p className="text-gray-700 leading-relaxed">
                                {selectedQuote.notes}
                              </p>
                            </div>
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Colonne de droite - Actions et historique */}
                  <div className="space-y-6">
                    {/* Statut détaillé */}
                    <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm">
                      <h5 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                        <svg
                          className="w-5 h-5 mr-3 text-blue-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                          />
                        </svg>
                        État de la demande
                      </h5>
                      <div className="space-y-3">
                        <div className="flex items-center space-x-3">
                          <div className="flex-shrink-0 w-3 h-3 bg-green-500 rounded-full"></div>
                          <div className="flex-1">
                            <p className="font-medium text-gray-800">
                              Demande reçue
                            </p>
                            <p className="text-sm text-gray-500">
                              Votre demande a été enregistrée
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center space-x-3">
                          <div
                            className={`flex-shrink-0 w-3 h-3 rounded-full ${
                              selectedQuote.status === "En attente"
                                ? "bg-yellow-500"
                                : "bg-gray-300"
                            }`}
                          ></div>
                          <div className="flex-1">
                            <p className="font-medium text-gray-800">
                              En traitement
                            </p>
                            <p className="text-sm text-gray-500">
                              Notre équipe étudie votre demande
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center space-x-3">
                          <div className="flex-shrink-0 w-3 h-3 bg-gray-300 rounded-full"></div>
                          <div className="flex-1">
                            <p className="font-medium text-gray-500">
                              Finalisation
                            </p>
                            <p className="text-sm text-gray-400">
                              En attente de confirmation
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Pied de la modal */}
              <div className="bg-gray-50 px-8 py-4 border-t border-gray-200">
                <div className="flex justify-end">
                  <button
                    onClick={handleCloseQuoteModal}
                    className="px-8 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700 transition-colors font-semibold shadow-lg"
                  >
                    Fermer le détail
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
